// ─── Insiders who bought or sold (sprint 21) ────────────────────────────────
//
// From Form 4, already stored in public.insider_transactions (the insider
// job, and sec-onboard for a new company). Only open-market trades: code P
// (a purchase) and S (a sale). Grants (A), option exercises (M), tax
// withholding (F), gifts (G) and the rest are left out by default · they are
// pay and plumbing, not a decision to buy or sell in the market.
// Facts only: who, what role, bought or sold, how many, at what price, when.

export const OPEN_MARKET = new Set(["P", "S"]);
export const TRADES_DAYS = 30;

/**
 * rows · insider_transactions rows (with `symbol` added by the caller)
 * → [{ symbol, name, title, side: "buy" | "sell", shares, price, date, url,
 *      count, priceLow, priceHigh }], newest first
 * The lines of one filing by one person, on one day and one side, are one
 * trade as the reader sees it: a CFO's sale reported in three price lots is
 * one row with the shares added up and the range of prices (count > 1).
 * Prices are not averaged: the range is what the filing says.
 */
export function openMarketTrades(rows, { days = TRADES_DAYS, now = new Date() } = {}) {
  const since = new Date(now.getTime() - days * 86400000).toISOString().slice(0, 10);
  return (rows || [])
    .filter(r => OPEN_MARKET.has(String(r.transaction_code || "").trim().toUpperCase()))
    .filter(r => String(r.transaction_date || "") >= since)
    .map(r => ({
      symbol: r.symbol, name: r.owner_name, title: r.owner_title || null,
      side: String(r.transaction_code).trim().toUpperCase() === "P" ? "buy" : "sell",
      shares: Number(r.shares) || null, price: Number(r.price_per_share) || null,
      date: r.transaction_date, url: r.source_url,
    }))
    .reduce((acc, t) => {
      const k = [t.symbol, t.name, t.side, t.date, t.url].join("|");
      const g = acc.map.get(k);
      if (!g) {
        const row = { ...t, count: 1, priceLow: t.price, priceHigh: t.price };
        acc.map.set(k, row); acc.list.push(row);
      } else {
        g.count += 1;
        g.shares = g.shares != null && t.shares != null ? g.shares + t.shares : null;
        if (t.price != null) {
          g.priceLow = g.priceLow == null ? t.price : Math.min(g.priceLow, t.price);
          g.priceHigh = g.priceHigh == null ? t.price : Math.max(g.priceHigh, t.price);
        }
        g.price = g.priceLow === g.priceHigh ? g.priceLow : null;
      }
      return acc;
    }, { map: new Map(), list: [] }).list
    .sort((a, b) => b.date.localeCompare(a.date));
}
